import {
  callGet,
  callPost,
  callPutById,
  callDelete,
} from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const getAllVehical = async (token) => {
  return await callGet(`${REQ.VEHICAL.GET_ALL_VEHICAL}`, token);
};

export const createVehical = async (data, token) => {
  return await callPost(REQ.VEHICAL.SAVE_DATA, data, token);
};

export const updateSingleVehical = async (data, token) => {
  return await callPutById(
    `${REQ.VEHICAL.UPDATE_VEHICAL}/${data.id}`,
    data,
    token
  );
};

export const deleteSingleVehical = async (data, token) => {
  return await callDelete(
    `${REQ.VEHICAL.DELETE_VEHICAL}/${data.id}`,
    data,
    token
  );
};
